import styled from "styled-components";
import React, { useEffect, useState } from 'react';
import P from "@src/components/atoms/p";
import { ThemeType } from "@src/types/theme";
import { t_library } from "@src/types/tables";
import CirclePauseIcon from "@src/components/icons/player/play/CirclePauseIcon";
import CirclePlayIcon from "@src/components/icons/player/play/CirclePlayIcon";
import { stripHtmlTags } from "@src/lib/public-lib";

export type DetailTitleProps = {
    data: t_library;
    handleItemPlay: (value: t_library) => void;
    handleItemPause: () => void;
    play: boolean;
    playId: string;
    setPlayId: (value: string) => void;
};

export default function DetailTitle(props: DetailTitleProps)
{
    const [ isPlay, setIsPlay ] = useState(false);

    function play()
    {
        props.handleItemPlay(props.data);
        props.setPlayId(props.data.id);
		setIsPlay(true);
	};

    function pause()
    {
        props.handleItemPause();
        setIsPlay(false);
    };

    useEffect(() => {
        if (props.data.id === props.playId)
            setIsPlay(props.play);
    }, [props.play]);

    useEffect(() => {
        if (props.data.id === props.playId)
            setIsPlay(true);
        else
            setIsPlay(false);
    }, [props.playId]);

	return (
		<Wrapper>
            { isPlay ?
                <CirclePauseIcon width={ 45 } height={ 45 } fill="white" onClick={ pause } />
                :
                <CirclePlayIcon width={ 45 } height={ 45 } fill="white" onClick={ play } />
            }
            <TitleText>
                { props.data.title }
            </TitleText>
            <DescText>
                { stripHtmlTags(props.data.desc) }
            </DescText>
            <ArtistText>
                { `by YULCOMPANY` }
            </ArtistText>
        </Wrapper>
	);
}

const Wrapper = styled.div`
	width: 100%;
    padding: 40px 40px 0 0;
    border-right: solid 2px #99999955;
    flex: 1;

    ${({ theme }: { theme: ThemeType }) => theme.largeTablet`
        border: none;
        padding-right: 0;
	`};
`;

const NormalText = styled(P)`
    font-size: 0.4rem;
    font-weight: 300;
    text-align: left;
    line-height: 0.4rem;
    color: ${({ theme }: { theme: ThemeType }) => theme.text};
`;

const TitleText = styled(NormalText)`
    width: fit-content;
    font-size: 0.65rem;
    line-height: 1.2;
    color: #F3B25A;
    font-family: Pretendard;
    font-size: 48px;
    font-style: normal;
    font-weight: 700;
    line-height: normal; 
    word-break: normal;
    margin: 15px 0;
    justify-content: start;
    user-select: text;

    svg {
        margin-right: 10px;
        transform: translateY(0.09rem);
    }
`;

const DescText = styled(NormalText)`
    color: #FFF;
    font-family: Pretendard;
    font-size: 16px;
    font-weight: 400;
    line-height: normal; 
    user-select: text;
`;

const ArtistText = styled(NormalText)`
    color: #999;
    margin-top: 16px;
    font-family: Pretendard;
    font-size: 16px;
    font-weight: 400;
    line-height: normal; 
    user-select: text;
`;